export default __webpack_public_path__ + "static/media/scb-color.85052071.svg";